
const InvitationLinkInfo = () => import("@/components/InvitationLinkInfo.vue");

import Vue from "vue";
import { OnboardingSupplements, RouteInvitationLink, ValidatedSteps } from "@/types/data";
import { Dictionary } from "lodash";
import { ActionTypes } from "@/enums/vuex";
export default Vue.extend({
    name: "CreatePasswordForm",
    data(): {
            loading: boolean
            showPassword: boolean
            showRepeatPassword: boolean
            passwordInput: string
            repeatPasswordInput: string
            passwordRules: any

    } {
        return {
            loading: false,
            showPassword: false,
            showRepeatPassword: false,
            passwordInput: "",
            repeatPasswordInput: "",
            passwordRules: [
                (v:string) => !!v || 'Passord må utfylles',
                (v:string) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&£€*()\-_¤=+[{\]};:'",<.>/?\\|~])[A-Za-z\d!@#$¤£€%^&*()\-_=+[{\]};:'",<.>/?\\|~]{8,}$/.test(v) || 'Passordet må inneholde store og små bokstaver, minst ett tall og ett spesialtegn',
                (v:string) => v.length <= 100 || 'Maks grense er 100 tegn ',
            ],
            
        }
    },
    watch: {

    },
    computed: {

        isFormValid(): boolean {
            let form: any
            form = this?.$refs?.passwordForm
            return form.validate() ?? false
        },

    },
    methods: {

        matchPasswords(){
            if(this.passwordInput === this.repeatPasswordInput){
                return true
            }else{
                return 'Passordene må være like'
            }
        },
        async updateFormValidity() {

            const isFormValid: boolean = this.isFormValid
            const validatedSteps: ValidatedSteps = await this.$store.getters.getContext.validatedSteps
            validatedSteps.createPasswordForm = isFormValid

            this.$store.dispatch(ActionTypes.setValidatedSteps, validatedSteps)

            if(isFormValid){
                this.updatePasswordInfo()
            }
            
        },
        async updatePasswordInfo(){

            let onboardingSupplements: OnboardingSupplements = await this.$store.getters.getContext.onboardingSupplements
            onboardingSupplements.password = this.passwordInput
            this.$store.dispatch(ActionTypes.setOnboardingSupplementInfo, onboardingSupplements)
            console.log("[CreatePasswordForm.updatePasswordInfo] Store onboardingSupplements updated: ", onboardingSupplements)
        }
    }
});
